<template>
  <v-col cols="12" class="text-center">
    <div class="font-weight-bold text-h6 justify-center">
      ¿Desea desvincular a {{ vinculado.nombrePersonal }} de esta capacitación?
    </div>
    <div class="justify-center pb-8 mt-4">
      <v-btn text class="mr-4" @click="CLOSE_DIALOG" :disabled="loading">Cancelar</v-btn>
      <TextButton color="red" @click="desvincular" :loading="loading" :disabled="loading">Aceptar</TextButton>
    </div>
  </v-col>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: { TextButton },
  props: {
    vinculado: { type: Object, required: true },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapMutations('dialog', ['CLOSE_DIALOG']),
    ...mapActions('capacitaciones', ['desvincularPersonalDeCurso']),
    async desvincular() {
      this.loading = true
      try {
        await this.desvincularPersonalDeCurso(this.vinculado.id)
        this.$emit('updated')
        this.CLOSE_DIALOG()
      } catch {
        // El store ya muestra el mensaje de error en el snackbar.
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
